/* Maa Mitahara - All Products collection: group chips, search, sort, size picker, AJAX add to cart. No dependencies. */
(function () {
  var root = document.getElementById('mm-all');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var E = function (id) { return document.getElementById(id); };
  var QA = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var inr = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var FREE = parseInt(root.dataset.free, 10) || 999;
  var CART = root.dataset.cartUrl || '/cart';
  var grp = 'all', q = '', cart = {};
  var total = QA('.card').length;

  /* remember the server order so "Recommended" can restore it */
  var orig = [];
  QA('.grp .grid').forEach(function (g) { orig.push([g, Array.prototype.slice.call(g.children)]); });

  function apply() {
    var shown = 0;
    QA('.grp').forEach(function (s) {
      var on = grp === 'all' || s.dataset.g === grp, n = 0;
      QA('.card', s).forEach(function (c) {
        var m = on && (!q || c.dataset.n.indexOf(q) > -1);
        c.hidden = !m;
        if (m) n++;
      });
      s.hidden = n === 0;
      shown += n;
    });
    E('mm-empty').hidden = shown > 0;
    E('mm-eq').textContent = E('mm-q').value.trim();
    var label = '';
    if (grp !== 'all') {
      var chip = root.querySelector('.achips [data-g="' + grp + '"]');
      if (chip) label = ' in ' + chip.firstChild.textContent.trim();
    }
    E('mm-acount').textContent = shown === total && !q && grp === 'all'
      ? 'Showing all ' + total + ' products'
      : 'Showing ' + shown + ' product' + (shown === 1 ? '' : 's') + label + (q ? ' matching “' + E('mm-q').value.trim() + '”' : '');
    E('mm-qclear').hidden = !q;
  }

  /* group chips */
  root.querySelector('.achips').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    grp = b.dataset.g;
    QA('.achips button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    apply();
    var bar = E('mm-abar'), hdr = parseInt(getComputedStyle(root).getPropertyValue('--mm-hdr'), 10) || 0;
    if (bar.getBoundingClientRect().top <= hdr + 8) E('mm-acount').scrollIntoView({ block: 'start' });
  });

  /* search */
  E('mm-q').addEventListener('input', function (e) { q = e.target.value.trim().toLowerCase(); apply(); });
  E('mm-qclear').addEventListener('click', function () { E('mm-q').value = ''; q = ''; apply(); E('mm-q').focus(); });
  E('mm-ereset').addEventListener('click', function () {
    E('mm-q').value = ''; q = ''; grp = 'all';
    QA('.achips button').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.g === 'all' ? 'true' : 'false'); });
    apply();
  });

  /* sort inside each group */
  E('mm-sort').addEventListener('change', function (e) {
    var v = e.target.value;
    orig.forEach(function (pair) {
      var k = pair[1].slice();
      if (v === 'lo') k.sort(function (a, b) { return a.dataset.p - b.dataset.p; });
      if (v === 'hi') k.sort(function (a, b) { return b.dataset.p - a.dataset.p; });
      if (v === 'az') k.sort(function (a, b) { return a.dataset.n.localeCompare(b.dataset.n); });
      k.forEach(function (c) { pair[0].appendChild(c); });
    });
  });

  /* cart bar + "In cart" badges */
  function upd(t, n) {
    var l = Math.max(0, FREE - t);
    if (E('mm-shipmsg'))
    E('mm-shipmsg').textContent = n
      ? (l ? inr(t) + ' in cart. Add ' + inr(l) + ' for free shipping' : inr(t) + ' in cart. Free shipping unlocked')
      : 'Free shipping over ' + inr(FREE);
    if (E('mm-fill')) E('mm-fill').style.width = Math.min(100, t / FREE * 100) + '%';
    document.body.classList.toggle('has-cart', n > 0);
  }
  function marks() {
    QA('.card').forEach(function (c) {
      var n = 0, ids = {};
      QA('[data-id]', c).forEach(function (b) { ids[b.dataset.id] = 1; });
      Object.keys(ids).forEach(function (i) { n += cart[i] || 0; });
      var m = c.querySelector('.incart');
      if (m) { m.hidden = !n; m.textContent = n ? 'In cart: ' + n : ''; }
      c.classList.toggle('has', n > 0);
    });
  }
  function readCart(c) {
    cart = {};
    c.items.forEach(function (i) { cart[i.variant_id] = (cart[i.variant_id] || 0) + i.quantity; });
    upd(c.total_price / 100, c.item_count);
    marks();
  }
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(readCart).catch(function () {});

  /* size picker + add to cart */
  root.addEventListener('click', function (e) {
    var s = e.target.closest('.sizes button');
    if (s && !s.disabled) {
      var c = s.closest('.card');
      QA('.sizes button', c).forEach(function (x) { x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
      var p = +s.dataset.p, m = +s.dataset.c, g = +s.dataset.g;
      c.dataset.p = p;
      c.querySelector('.pr').innerHTML = '<b>' + inr(p) + '</b>' + (m > p ? ' <s>MRP ' + inr(m) + '</s>' : '') +
        '<span class="per">' + (g > 0 ? inr(p / g * 100) + ' per 100 g' : '') + '</span>';
      var a = c.querySelector('[data-add]');
      a.dataset.id = s.dataset.id; a.dataset.p = p;
      a.textContent = 'Add ' + s.dataset.s + ' · ' + inr(p);
      return;
    }
    var b = e.target.closest('[data-add]');
    if (!b || b.disabled) return;
    var st = b.nextElementSibling, id = b.dataset.id;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (c) {
      readCart(c);
      st.className = 'status'; st.textContent = 'Added to cart';
      var T = E('mm-toast');
      E('mm-tmsg').textContent = b.dataset.n + ' added';
      T.style.display = 'flex';
      clearTimeout(T._t); T._t = setTimeout(function () { T.style.display = 'none'; }, 3500);
      /* tell the theme's own cart bubble / drawer, if it listens (harmless if not) */
      ['cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach(function (n) {
        try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: c } })); } catch (_) {}
      });
    }).catch(function () {
      st.className = 'status err';
      st.textContent = 'Couldn’t add. Try again or order on WhatsApp.';
    }).then(function () {
      b.disabled = false; b.removeAttribute('aria-busy');
    });
  });

  apply();
})();
